import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpSentEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { HttpHeaderResponse, HttpProgressEvent, HttpResponse, HttpUserEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { DeviceDetectorService } from 'ngx-device-detector';

@Injectable()
export class HttpLogginInterceptor implements HttpInterceptor {

  constructor(private deviceService: DeviceDetectorService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpSentEvent
    | HttpHeaderResponse | HttpProgressEvent | HttpResponse<any> | HttpUserEvent<any> | any> {
    const diag = localStorage.getItem('diagnostico') === '1';

    if (diag) {
      const startTimestamp = new Date().getTime();

      const newReq = req.clone({
        headers: req.headers.set('startTimestamp', startTimestamp.toString())
      });

      return next.handle(newReq)
        .pipe(
          tap((res: HttpResponse<any>) => {
            if (res.url && res.url.includes('atendimento.satturno.com.br')) {
              const endTimestamp: number = new Date().getTime();
              const responseTime = endTimestamp - startTimestamp;

              if (responseTime >= 2000) {
                const deviceInfo = this.deviceService.getDeviceInfo();

                const jsonLog = {
                  responseTime: responseTime,
                  url: req.url,
                  device: deviceInfo
                };

                let weblog: any = localStorage.getItem('weblog');

                if (!weblog)
                  localStorage.setItem('weblog', JSON.stringify([jsonLog]));
                else {
                  weblog = JSON.parse(weblog);
                  weblog.push(jsonLog);

                  localStorage.setItem('weblog', JSON.stringify(weblog));
                }
              }
            }
          })
        );
    } else
      return next.handle(req);
  }
}
